module.exports = __webpack_public_path__ + "img/1.05.thmb.xs.3ca77cf8.jpg";